import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ProjectDtoKeysEnum } from '@zaoblako/shared/modules/project/enum/project-dto-keys.enum';

import * as yup from 'yup';

/** Deadline delay request response body - DTO signature */
export interface DeadlineDelayRequestFindInterface {
  /** Desired deadline value */
  deadline: Date;
  /** Additional commentary for request */
  commentary?: string;
  /** User who requests deadline change */
  user: UserFindInterface;
}

/** Deadline delay request response body - DTO schema */
export const DeadlineDelayRequestFindDto = SerdeDtoClass.create<DeadlineDelayRequestFindInterface>(ProjectDtoKeysEnum.DEADLINE_DELAY_REQUEST_FIND_DTO, {
  deadline: {
    label: 'Новый дедлайн',
    serializer: yup.date(),
  },
  commentary: {
    optional: true,
    label: 'Комментарий',
    serializer: yup.string(),
  },
  user: {
    optional: true,
    label: 'Пользователь',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
});
